import { useState, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { ThemeProvider, Global } from '@emotion/react'
import { loadGapiInsideDOM } from 'gapi-script'

import theme, { globalStyles } from 'theme'
import { useSettingsStore, useLoginStore } from 'stores'
import { useGoogleAppdata } from 'hooks'

import Login from './Login/Login'
import Home from './Home/Home'
import Edit from './Edit/Edit'
import Timer from './Timer/Timer'
import About from './About/About'
import Privacy from './Privacy/Privacy'
import Settings from './Settings/Settings'
import Import from './Import/Import'
import NotFound from './NotFound/NotFound'

import {
  Navigation,
} from 'components'

const Pages = () => {
  const themePreference = useSettingsStore(state => state.theme)
  const darkQuery = window.matchMedia('(prefers-color-scheme: dark)')
  const isLoggedIn = useLoginStore(state => state.isLoggedIn)
  const setIsLoggedIn = useLoginStore(state => state.setIsLoggedIn)
  const [isDark, setIsDark] = useState(darkQuery.matches)
  const { load } = useGoogleAppdata()

  // Register dark mode listener
  darkQuery.addEventListener('change', e => themePreference === 'system' && setIsDark(e.matches))
  // Detect dark mode updates
  useEffect(() => {
    setIsDark(themePreference === 'system' ? darkQuery.matches : themePreference === 'dark')
  }, [themePreference, darkQuery.matches])

  useEffect(() => {
    load()
  }, [isLoggedIn, load])

  useEffect(() => {
    // Google login
    const googleLogin = async () => {
      const gapi = await loadGapiInsideDOM()
      gapi.load('client:auth2', () => {
        window.gapi.client.init({
          clientId: '186421475342-l5vj0ugdk42gus9disgk33nfis2r9fhs.apps.googleusercontent.com',
          discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
          scope: 'profile email https://www.googleapis.com/auth/drive.appdata',
        })
          .then(() => {
            // Listen for state changes
            window.gapi.auth2.getAuthInstance().isSignedIn.listen(isSignedIn => setIsLoggedIn(isSignedIn))

            // Handle initial sign-in state
            setIsLoggedIn(window.gapi.auth2.getAuthInstance().isSignedIn.get())
          })
          .catch(e => {
            console.error(e)
            setIsLoggedIn(false)
          })
      })
    }
    
    googleLogin()
  }, [setIsLoggedIn])

  return (
    <ThemeProvider theme={theme(isDark)}>
      <Global styles={globalStyles} />

      <Navigation />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/timer/:id" element={<Timer />} />
        <Route path="/new" element={<Edit />} />
        <Route path="/timer/:id/edit" element={<Edit />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/import" element={<Import />} />
        <Route path="/import/:data" element={<Import />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ThemeProvider>
  )
}

export default Pages